// extracted by mini-css-extract-plugin
var _1 = "FooterActions-moduleFooterActions__yt0vk";
export { _1 as "FooterActions" }
